
export enum FlexBox {
  FLEX = 'd--f',
  INLINE_FLEX = 'd--if',
}

export enum FlexDirection {
  ROW = 'fd--r',
  ROW_REVERSE = 'fd--rr',
  COLUMN = 'fd--c',
  COLUMN_REVERSE = 'fd--cr',
}

export enum FlexWrap {
  NOWRAP = 'fw--n',
  WRAP = 'fw--w',
  WRAP_REVERSE = 'fw--wr',
}

export enum JustifyContent {
  FLEX_END = 'jc--fe',
  FLEX_START = 'jc--fs',
  CENTER = 'jc--c',
  SPACE_AROUND = 'jc--sa',
  SPACE_BETWEEN = 'jc--sb',
}

export enum AlignItems {
  FLEX_START = 'ai--fs',
  CENTER = 'ai--c',
  FLEX_END = 'ai--fe',
  STRETCH = 'ai--s',
  BASELINE = 'ai--b',
}

export enum FlexGrow {
  GROW_1 = 'fg--1',
  GROW_0 = 'fg--0',
}

export enum FlexShrink {
  SHRINK_1 = 'fs--1',
  SHRINK_0 = 'fs--0',
}

export enum AlignSelf {
  AUTO = 'as--a',
  FLEX_START = 'as--fs',
  CENTER = 'as--c',
  FLEX_END = 'as--fe',
  STRETCH = 'as--s',
  BASELINE = 'as--b',
}
